var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"mouseenter":_vm.mouseenter,"mouseleave":_vm.mouseleave}},[_c('input',{staticClass:"calendar-input",staticStyle:{"cursor":"pointer"},attrs:{"id":"hdpkr","type":"text","placeholder":_vm.placeholder,"autocomplete":"off"}})])}
var staticRenderFns = []

export { render, staticRenderFns }